/**
 * Debounce de termo — 1 request por PAUSA de digitação, não por tecla.
 *
 * Mora em módulo próprio de propósito: as facetas Pessoas, Operadores e
 * Documentos todas o usam, e quando ele morava dentro de `use-people-hits`
 * qualquer teste que mockasse aquele módulo derrubava as outras facetas junto.
 * Utilitário compartilhado não mora dentro de um consumidor.
 */
import { useEffect, useState } from 'react';

export const DEBOUNCE_MS = 300;

export function useDebounced(value: string, ms = DEBOUNCE_MS): string {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => {
      setDebounced(value);
    }, ms);
    return () => {
      clearTimeout(t);
    };
  }, [value, ms]);
  return debounced;
}
